import request from '@/modules/huyu-framework/backend/utils/request'

// 查询知识库列表（不分页）
// 后端 startPage() 默认 pageNum=1/pageSize=10，不传参会把列表截断为前10条；
// 传 pageSize=-1 走 PageUtils 的不分页分支，返回全部
export function listKnowledgeNoPage() {
  return request({
    url: '/huyuAI/knowledge/list',
    method: 'get',
    params: { pageSize: -1 }
  })
}

// 查询知识库详细
export function getKnowledge(id) {
  return request({
    url: '/huyuAI/knowledge/' + id,
    method: 'get'
  })
}

// 新增知识库
export function addKnowledge(data) {
  return request({
    url: '/huyuAI/knowledge',
    method: 'post',
    data: data
  })
}

// 修改知识库
export function updateKnowledge(data) {
  return request({
    url: '/huyuAI/knowledge',
    method: 'put',
    data: data
  })
}

// 删除知识库
export function deleteKnowledge(id) {
  return request({
    url: '/huyuAI/knowledge/' + id,
    method: 'delete'
  })
}
